import { useEvent } from "./events.mjs";
import { useStoredUser } from "./auth/storage.mjs";
import { useNuxtApp } from "#app";
export var TRACKING_EVENTS = /* @__PURE__ */ ((TRACKING_EVENTS2) => {
  TRACKING_EVENTS2["ADD_TO_CART"] = "ADD_TO_CART";
  TRACKING_EVENTS2["ADD_TO_WISH_LIST"] = "ADD_TO_WISH_LIST";
  TRACKING_EVENTS2["COMPLETE_REGISTRATION"] = "COMPLETE_REGISTRATION";
  TRACKING_EVENTS2["SEARCH"] = "Search";
  TRACKING_EVENTS2["PURCHASE"] = "Purchase";
  TRACKING_EVENTS2["ON_PRODUCT"] = "ON_PROUDCT";
  TRACKING_EVENTS2["PRODUCT_CLICK"] = "PRODUCT_CLICK";
  TRACKING_EVENTS2["PRODUCT_VIEW"] = "PRODUCT_VIEW";
  TRACKING_EVENTS2["PRODUCT_REMOVE_FROM_CART"] = "PRODUCT_REMOVE_FROM_CART";
  TRACKING_EVENTS2["CHECKOUT_STEP"] = "CHECKOUT_STEP";
  TRACKING_EVENTS2["CHECKOUT_STEP_OPTION"] = "CHECKOUT_STEP_OPTION";
  return TRACKING_EVENTS2;
})(TRACKING_EVENTS || {});
export function useTrackingHandlers() {
  const gtag = useNuxtApp()?.$gtag;
  const { user } = useStoredUser();
  useEvent("Purchase" /* PURCHASE */, (order) => {
    gtag("purchase", {
      order: {
        number: order?.id || "",
        total: order?.total,
        shippingFees: order?.shippingFees
      },
      items: order?.items,
      transactionData: {
        transactionId: order?.items?.map((product) => product?.sku),
        transactionName: "order_success",
        transactionTotal: order?.total,
        transactionCurrency: "EGP",
        transactionType: "product_group",
        transactionNumItems: order?.items?.length,
        transactionContent: order?.items?.map((product) => ({
          id: product?.sku,
          quantity: product?.quantity || 0
        })),
        transactionAddress: {
          firstname: order?.shipping_address?.firstname,
          lastname: order?.shipping_address?.lastname,
          email: user?.value?.email,
          phone_number: `+20${order?.shipping_address?.telephone}`,
          street: order?.shipping_address?.street,
          city: order?.shipping_address?.city,
          region: order?.shipping_address?.region,
          country: "Egypt",
          postalcode: "12345"
        }
      },
      ga4: {
        currency: "EGP",
        transaction_id: order?.id,
        value: order?.total,
        affiliation: "",
        // TODO be added later
        coupon: "",
        // TODO be added later
        shipping: order?.shippingFees,
        tax: 0,
        // TODO be added later
        items: order?.items?.map((product, idx) => ({
          item_id: product?.sku,
          item_name: product?.name,
          affiliation: "",
          // TODO be added later
          coupon: "",
          // TODO be added later
          currency: "EGP",
          discount: "",
          index: idx,
          item_brand: product?.brand,
          item_category: product?.category,
          price: product?.price,
          quantity: product?.quantity
        }))
      }
    });
  });
  useEvent("Search" /* SEARCH */, (keyword) => {
    gtag("search", {
      transactionData: {
        transactionContent: keyword,
        transactionCurrency: "EGP",
        transactionValue: user.value ? user.value.id : null
      },
      ga4: {
        search_term: keyword
      }
    });
  });
  useEvent(
    "COMPLETE_REGISTRATION" /* COMPLETE_REGISTRATION */,
    (customer) => {
      gtag("completing_registration", {
        transactionData: {
          transactionContent: customer.firstname + " " + customer.lastname,
          transactionCurrency: "EGP",
          transactionValue: user.value ? user.value.id : null,
          transactionStatus: "active"
        }
      });
    }
  );
  useEvent(
    "ADD_TO_WISH_LIST" /* ADD_TO_WISH_LIST */,
    (product) => {
      gtag("add_to_wishlist", {
        transactionData: {
          transactionName: product.name,
          transactionId: [product.id],
          transactionContent: product.name,
          transactionValue: user.value ? user.value.id : null,
          // user id
          transactionCategory: product?.categories?.[0]?.name,
          currency: "EGP"
        },
        ga4: {
          currency: "EGP",
          value: product.price,
          items: [product].map((product2, idx) => ({
            item_id: product2?.sku,
            item_name: product2?.name,
            affiliation: "",
            // TODO be added later
            coupon: "",
            // TODO be added later
            currency: "EGP",
            discount: "",
            index: idx,
            item_brand: product2?.brand?.name,
            item_category: product2?.categories?.[0]?.name,
            price: product2?.price,
            quantity: 1
          }))
        }
      });
    }
  );
  useEvent("ON_PROUDCT" /* ON_PRODUCT */, (product) => {
    gtag("product_impression", { ...product });
  });
  useEvent("PRODUCT_CLICK" /* PRODUCT_CLICK */, (product) => {
    gtag("product_click", {
      ...product,
      ga4: {
        items: [product].map((product2, idx) => ({
          item_id: product2?.sku,
          item_name: product2?.name,
          affiliation: "",
          // TODO be added later
          coupon: "",
          // TODO be added later
          currency: "EGP",
          discount: "",
          index: idx,
          item_brand: product2?.brand?.name || "",
          item_category: product2?.categories?.[0]?.name,
          price: product2?.price,
          quantity: 1
        }))
      }
    });
  });
  useEvent(
    "ADD_TO_CART" /* ADD_TO_CART */,
    (cartItem) => {
      gtag("product_added_to_cart", {
        product: cartItem,
        quantity: cartItem.quantity,
        transactionData: {
          transactionName: cartItem.name,
          transactionTotal: Number(cartItem.unitPrice).toFixed(2),
          transactionCurrency: "EGP",
          transactionCategory: cartItem.mainCategory,
          transactionType: "product",
          transactionContent: [cartItem.id]
        },
        ga4: {
          currency: "EGP",
          value: cartItem.quantity * cartItem.unitPrice,
          items: [cartItem].map((product, idx) => ({
            item_id: product?.sku,
            item_name: product?.name,
            affiliation: "",
            // TODO be added later
            coupon: "",
            // TODO be added later
            currency: "EGP",
            discount: "",
            index: idx,
            item_brand: "",
            item_category: product?.mainCategory,
            price: product?.unitPrice,
            quantity: product?.quantity
          }))
        }
      });
    }
  );
  useEvent(
    "PRODUCT_REMOVE_FROM_CART" /* PRODUCT_REMOVE_FROM_CART */,
    (cartItem) => {
      gtag("product_removed_from_cart", {
        product: cartItem,
        quantity: cartItem?.quantity,
        ga4: {
          currency: "EGP",
          value: cartItem?.quantity * cartItem?.unitPrice,
          items: [cartItem].map((product, idx) => ({
            item_id: product?.sku ?? "N/A",
            item_name: product?.name,
            affiliation: "",
            // TODO be added later
            coupon: "",
            // TODO be added later
            currency: "EGP",
            discount: "",
            index: idx,
            item_brand: "",
            item_category: product?.mainCategory,
            price: product?.unitPrice,
            quantity: product?.quantity
          }))
        }
      });
    }
  );
  useEvent("PRODUCT_VIEW" /* PRODUCT_VIEW */, (product) => {
    gtag("product_detail_views", {
      product,
      transactionData: {
        transactionName: product.name,
        transactionTotal: Number(product.price).toFixed(2),
        transactionCurrency: "EGP",
        transactionCategory: product?.categories?.[0]?.name,
        transactionType: "product",
        transactionContent: [product.id]
      },
      ga4: {
        currency: "EGP",
        value: product.price,
        items: [product].map((product2, idx) => ({
          item_id: product2?.sku,
          item_name: product2?.name,
          affiliation: "",
          // TODO be added later
          coupon: "",
          // TODO be added later
          currency: "EGP",
          discount: "",
          index: idx,
          item_brand: "",
          item_category: product2?.categories?.[0]?.name,
          price: product2?.price,
          quantity: 1
        }))
      }
    });
  });
  useEvent(
    "CHECKOUT_STEP" /* CHECKOUT_STEP */,
    ({
      step,
      products
    }) => {
      products && products.length && gtag("checkout_step", { step, items: products });
    }
  );
  useEvent(
    "CHECKOUT_STEP_OPTION" /* CHECKOUT_STEP_OPTION */,
    ({
      step,
      products,
      option
    }) => {
      products && products.length && gtag("checkout_step_option", { step, items: products, option });
    }
  );
}
